import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import axios from "axios";
import { base_url } from "../context/Authcontext";
import { useNavigate } from "react-router-dom";
import TopBar from "./components/TopNavbar";
import MarqueeBottom from "./components/MarqueeBottom";
import { useTheme } from "../context/ThemeContext";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero
  const day = date.getDate().toString().padStart(2, "0"); // Add leading zero
  return `${year}-${month}-${day}`; // Format as 'YYYY-MM-DD'
};

const compareWithToday = (openDate) => {
  const now = new Date();

  // Get today's date
  const today = formatDate(now);

  // Get tomorrow's date by adding 1 day to the current date
  const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // 24 hours in milliseconds

  // Convert openDate string to Date object
  const eventDateObj = new Date(openDate);

  const eventDateFormatted = formatDate(eventDateObj);

  return eventDateFormatted === today || eventDateFormatted === tomorrow;
};

const checkOpenDate = (openDate) => {
  const currentTime = new Date();
  const eventDate = new Date(openDate);

  // Convert both times to IST
  const currentIST = new Date(currentTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  const eventIST = new Date(eventDate.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

  if (eventIST <= currentIST) {
    return "InPlay";
  }

  const isToday =
    currentIST.getFullYear() === eventIST.getFullYear() &&
    currentIST.getMonth() === eventIST.getMonth() &&
    currentIST.getDate() === eventIST.getDate();

  if (isToday) {
    return "Today";
  }

  // Else return formatted date
  return `${eventIST.getDate().toString().padStart(2, "0")}-${(eventIST.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${eventIST.getFullYear()}`;
};


export const InplayGames = () => {
  const navigate = useNavigate();
  const [isSidebar, setSidebar] = useState(false);
  const [cricket, setCricket] = useState([]);
  const [soccer, setSoccer] = useState([]);
  const [tennis, setTennis] = useState([]);
  const [cric, setCric] = useState([]);
  const [socc, setSocc] = useState([]);
  const { themeColors } = useTheme();
  const [avail, setAvail] = useState([]);


  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);


  const matchData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/matchapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;
      // console.log("Data is ", data)

      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        // console.log(
        //   "openDate",
        //   openDate,
        //   "compare",
        //   compareWithToday(openDate)
        // );

        // Use the updated compareWithToday function
        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });
      // console.log('all',allData);
      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/footballapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = response?.data.result;

      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;

        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });

      setSoccer(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const tennisData = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/tennisapi", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("API Response:", response?.data.result);
      const data = response?.data.result;

      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;

        // Use the updated compareWithToday function
        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });

      setTennis(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const oddsData1 = async (req, res) => {
    // console.log("Data is working ");
    let marketid = [];

    // console.log("Cricket dats in the odds are ", cricket);

    try {
      for (let item of cricket) {
        // console.log("items", item);
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setCric(result);
    } catch (err) {
      console.log(err);
    }
  };

  const oddsData2 = async (req, res) => {
    let marketid = [];

    try {
      for (let item of soccer) {
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setSocc(result);
    } catch (err) {
      console.log(err);
    }
  };

  const oddsData3 = async (req, res) => {
    let marketid = [];

    try {
      for (let item of tennis) {
        marketid.push(item.marketId);
      }
      // console.log(marketid);

      const response = await axios.post(
        base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log('marketid',JSON.parse(response.data));
      const result = JSON.parse(response.data);
      setAvail(result);
    } catch (err) {
      console.log(err);
    }
  };

  const odds = async () => {
    await oddsData1();
    await oddsData2();
    await oddsData3();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    handleResize();
    matchData();
    footballData();
    tennisData();
  }, []);

  useEffect(() => {
    if (
      Array.isArray(cricket) &&
      Array.isArray(soccer) &&
      Array.isArray(tennis)
    ) {
      odds(); // ✅ will only run when all are fetched
    }
  }, [cricket, soccer, tennis]);

  // console.log('criket is devansh',cricket);
  // console.log('socc',soccer);
  // console.log('tenn',tennis);

  const handleClick = (item) => {
    // console.log(item);

    sessionStorage.setItem('marketId', item.marketId);
    sessionStorage.setItem('competetionid', item.competition.id);
    sessionStorage.setItem('eventid', item.event.id);
    sessionStorage.setItem('time', item?.event.openDate);
    sessionStorage.setItem('competitionname', item?.competition.name);
    sessionStorage.setItem('eventname', item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate('/cricketBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);


    } else if (item.eventType.name === "Soccer") {
      navigate('/footBAllBet');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);
      sessionStorage.setItem('selectionid3', item?.runners[2].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);

    } else if (item.eventType.name === "Tennis") {
      navigate('/tennis');
      sessionStorage.setItem('selectionid1', item?.runners[0].selectionId);
      sessionStorage.setItem('selectionid2', item?.runners[1].selectionId);

      sessionStorage.setItem('runner1', item.runners[0].runnerName);
      sessionStorage.setItem('runner2', item.runners[1].runnerName);

    }

  }

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const greenCircles = document.querySelectorAll('.green-circle');
  console.log('Total Green Circles:', greenCircles.length);


  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">

            {/* {isLargeScreen && <TopBar />} */}
            <Header isSidebar={isSidebar} setSidebar={setSidebar} show={showCanvas} handleShow={handleCanvasShow} handleClose={handleCanvasClose} />

            <div _ngcontent-jrx-c95="" className="body-container mb-5">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  paddingLeft: isLargeScreen ? "0px" : '0px',
                  paddingRight: isLargeScreen ? "3px" : '0px',
                  width: isSidebar ? "" : "2500%",
                  transition: "width 0.3s ease-in-out",
                  backgroundColor: themeColors['--dark-theme-data-bg'],
                }}
              >

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >

                  {isLargeScreen && (
                    <div className="match-header d-flex flex-column w-100">

                      <div className="row ms-xl-0 px-1 py-2 bet-table-header1 border border-top-0">
                        <div className="col-lg-8 ps-xl-1 mb-0">
                          <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>Cricket</h6>
                        </div>
                        <div className="col-lg-4 mb-0">
                          <div className="row mb-0">
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>1</h6>
                            </div>
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>X</h6>
                            </div>
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>2</h6>
                            </div>
                          </div>
                        </div>
                      </div>

                      {cricket?.length > 0 ? (
                        cricket
                          ?.filter(
                            (item) =>
                              checkOpenDate(item?.event.openDate) === "InPlay" &&
                              cric[item.marketId] &&
                              cric[item.marketId].length > 0 &&
                              cric[item.marketId].some(
                                (market) =>
                                  market?.ex?.availableToBack?.length > 0 ||
                                  market?.ex?.availableToLay?.length > 0
                              )
                          )
                          .map((item, index) => {
                            const marketData = cric[item.marketId] || [];

                            if (!marketData) return null;
                            return (
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competition?.id}
                                className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div >
                                  <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team"
                                            >

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name d-flex t_left fs-4"
                                                onClick={() => handleClick(item)}
                                              >

                                                {" "}
                                                {item.runners[0].runnerName}{" "}
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                {item.runners[1].runnerName}

                                                <span className="fszz ms-1">
                                                  {(() => {
                                                    const date = new Date(item?.event.openDate);
                                                    const dd = String(date.getDate()).padStart(2, '0');
                                                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                    const yyyy = date.getFullYear();

                                                    let hours = date.getHours();
                                                    const minutes = String(date.getMinutes()).padStart(2, '0');
                                                    const seconds = String(date.getSeconds()).padStart(2, '0');

                                                    const ampm = hours >= 12 ? 'PM' : 'AM';
                                                    hours = hours % 12;
                                                    hours = hours ? hours : 12;
                                                    const hh = String(hours).padStart(2, '0');

                                                    return `${dd}/${mm}/${yyyy} ${hh}:${minutes}:${seconds} ${ampm}`;
                                                  })()}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex" style={{ marginTop: "2px", }}>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate)
                                                  ? "green-circle inplay-blinker ng-star-inserted"
                                                  : ""
                                                  }`}
                                              ></div>
                                              <img
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate) ? 'small-grid ng-star-inserted' : 'd-none'}`}
                                                style={{ height: "18px", width: "18px" }}
                                                src="/assets/paneal_images/tv (1).png"
                                                alt="TVKheloyaar360"
                                              />

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid" src="/assets/paneal_images/bm-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid ms-1" src="assets/paneal_images/fancy-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid mx-2" src="/assets/paneal_images/patte.webp" />
                                                </span>
                                              </div>

                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper"
                                              style={{ position: "relative", }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >

                                                    {marketData && marketData.length > 0 && (
                                                      <div className="d-flex runnners-odds-details">
                                                        {(() => {
                                                          let backDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToBack?.length > 0
                                                              ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                              : []
                                                          );
                                                          let layDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToLay?.length > 0
                                                              ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                              : []
                                                          );

                                                          // Fill up with empty divs if needed to ensure 6 elements
                                                          while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                          while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                          let combinedDivs = [
                                                            backDivs[0],
                                                            layDivs[0],
                                                            { price: null, type: "Back" }, // Empty Back
                                                            { price: null, type: "Lay" }, // Empty Lay
                                                            backDivs[1],
                                                            layDivs[1],
                                                          ];

                                                          return combinedDivs.map((item, index) => (
                                                            <app-oddsbutton key={index}>
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                              //  onClick={()=>handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !== null ? item.price : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          ));
                                                        })()}
                                                      </div>
                                                    )}

                                                  </div>
                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div>No Matches Found.</div>
                      )}
                      <div className="row ms-xl-0 px-1 py-2 bet-table-header1 border border-top-0">
                        <div className="col-lg-8 ps-xl-1 mb-0">
                          <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>Soccer</h6>
                        </div>
                        <div className="col-lg-4 mb-0">
                          <div className="row mb-0">
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>1</h6>
                            </div>
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>X</h6>
                            </div>
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>2</h6>
                            </div>
                          </div>
                        </div>
                      </div>

                      {soccer?.length > 0 ? (
                        soccer
                          ?.filter(
                            (item) =>
                              checkOpenDate(item?.event.openDate) === "InPlay" &&
                              socc[item.marketId] &&
                              socc[item.marketId].length > 0 &&
                              socc[item.marketId].some(
                                (market) =>
                                  market?.ex?.availableToBack?.length > 0 ||
                                  market?.ex?.availableToLay?.length > 0
                              )
                          )
                          .map((item, index) => {
                            const marketData = socc[item.marketId] || [];
                            if (!marketData) return null;
                            return (
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competition?.id}
                                className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div>

                                  <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team"
                                            >

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name d-flex t_left fs-4"
                                                onClick={() => handleClick(item)}
                                              >

                                                {" "}
                                                {item.runners[0].runnerName}{" "}
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                {item.runners[1].runnerName}
                                                <span className="fszz ms-1">
                                                  {(() => {
                                                    const date = new Date(item?.event.openDate);
                                                    const dd = String(date.getDate()).padStart(2, '0');
                                                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                    const yyyy = date.getFullYear();

                                                    let hours = date.getHours();
                                                    const minutes = String(date.getMinutes()).padStart(2, '0');
                                                    const seconds = String(date.getSeconds()).padStart(2, '0');

                                                    const ampm = hours >= 12 ? 'PM' : 'AM';
                                                    hours = hours % 12;
                                                    hours = hours ? hours : 12;
                                                    const hh = String(hours).padStart(2, '0');

                                                    return `${dd}/${mm}/${yyyy} ${hh}:${minutes}:${seconds} ${ampm}`;
                                                  })()}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex" style={{ marginTop: "2px", }}>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate)
                                                  ? "green-circle inplay-blinker ng-star-inserted"
                                                  : ""
                                                  }`}
                                              ></div>
                                              <img
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate) ? 'small-grid ng-star-inserted' : 'd-none'}`}
                                                style={{ height: "18px", width: "18px" }}
                                                src="/assets/paneal_images/tv (1).png"
                                                alt="TVKheloyaar360"
                                              />

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid" src="/assets/paneal_images/bm-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid ms-1" src="assets/paneal_images/fancy-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid mx-2" src="/assets/paneal_images/patte.webp" />
                                                </span>
                                              </div>

                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper"
                                              style={{ position: "relative", }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >

                                                    {marketData && marketData.length > 0 ? (
                                                      <div className="d-flex runnners-odds-details">
                                                        {(() => {
                                                          let backDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToBack?.length > 0
                                                              ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                              : []
                                                          );
                                                          let layDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToLay?.length > 0
                                                              ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                              : []
                                                          );

                                                          // Fill up with empty divs if needed to ensure 6 elements
                                                          while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                          while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                          let combinedDivs = [
                                                            backDivs[0],
                                                            layDivs[0],
                                                            { price: null, type: "Back" }, // Empty Back
                                                            { price: null, type: "Lay" }, // Empty Lay
                                                            backDivs[1],
                                                            layDivs[1],
                                                          ];

                                                          return combinedDivs.map((item, index) => (
                                                            <app-oddsbutton key={index}>
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                              //  onClick={()=>handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !== null ? item.price : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          ));
                                                        })()}
                                                      </div>
                                                    ) :
                                                      <div>No playinng match</div>
                                                    }

                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div>No Playing Match.</div>
                      )}

                      <div className="row ms-xl-0 px-1 py-2 bet-table-header1 border border-top-0">
                        <div className="col-lg-8 ps-xl-1 mb-0">
                          <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>Tennis</h6>
                        </div>
                        <div className="col-lg-4 mb-0">
                          <div className="row mb-0">
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>1</h6>
                            </div>
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>X</h6>
                            </div>
                            <div className="col-lg-4 mb-0">
                              <h6 className="my-0 fw-bold" style={{ color: themeColors['--text-body'] }}>2</h6>
                            </div>
                          </div>
                        </div>
                      </div>

                      {tennis?.length > 0 ? (
                        tennis
                          ?.filter(
                            (item) =>
                              checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
                              avail[item.marketId] &&
                              avail[item.marketId].length > 0 &&
                              avail[item.marketId].some(
                                (market) =>
                                  market?.ex?.availableToBack?.length > 0 ||
                                  market?.ex?.availableToLay?.length > 0
                              )
                          )
                          .map((item, index) => {
                            const marketData = avail[item.marketId] || [];

                            // console.log('marketdata',marketData);

                            if (!marketData) return null;
                            return (
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competition?.id}
                                className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div>
                                  {/* <p>{item.marketId}</p> */}
                                  <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team"
                                            >

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name d-flex t_left fs-4"
                                                onClick={() => handleClick(item)}
                                              >
                                                {" "}
                                                {item.runners[0].runnerName}{" "}
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                {item.runners[1].runnerName}
                                                <span className="fszz ms-1">
                                                  {(() => {
                                                    const date = new Date(item?.event.openDate);
                                                    const dd = String(date.getDate()).padStart(2, '0');
                                                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                                                    const yyyy = date.getFullYear();

                                                    let hours = date.getHours();
                                                    const minutes = String(date.getMinutes()).padStart(2, '0');
                                                    const seconds = String(date.getSeconds()).padStart(2, '0');

                                                    const ampm = hours >= 12 ? 'PM' : 'AM';
                                                    hours = hours % 12;
                                                    hours = hours ? hours : 12;
                                                    const hh = String(hours).padStart(2, '0');

                                                    return `${dd}/${mm}/${yyyy} ${hh}:${minutes}:${seconds} ${ampm}`;
                                                  })()}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex" style={{ marginTop: "2px", }}>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail"
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate)
                                                  ? "green-circle inplay-blinker ng-star-inserted"
                                                  : ""
                                                  }`}
                                              ></div>
                                              <img
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate) ? 'small-grid ng-star-inserted' : 'd-none'}`}
                                                style={{ height: "18px", width: "18px" }}
                                                src="/assets/paneal_images/tv (1).png"
                                                alt="TVKheloyaar360"
                                              />

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid" src="/assets/paneal_images/bm-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid ms-1" src="assets/paneal_images/fancy-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid mx-2" src="/assets/paneal_images/patte.webp" />
                                                </span>
                                              </div>

                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper"
                                              style={{ position: "relative", }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >

                                                    {marketData && marketData.length > 0 && (
                                                      <div className="d-flex runnners-odds-details">
                                                        {(() => {
                                                          let backDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToBack?.length > 0
                                                              ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                              : []
                                                          );
                                                          let layDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToLay?.length > 0
                                                              ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                              : []
                                                          );

                                                          // Fill up with empty divs if needed to ensure 6 elements
                                                          while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                          while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                          let combinedDivs = [
                                                            backDivs[0],
                                                            layDivs[0],
                                                            { price: null, type: "Back" }, // Empty Back
                                                            { price: null, type: "Lay" }, // Empty Lay
                                                            backDivs[1],
                                                            layDivs[1],
                                                          ];

                                                          return combinedDivs.map((item, index) => (
                                                            <app-oddsbutton key={index}>
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                              //  onClick={()=>handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !== null ? item.price : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          ));
                                                        })()}
                                                      </div>
                                                    )}

                                                  </div>

                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div>No Matches Found.</div>
                      )}
                    </div>
                  )}

                  {!isLargeScreen && (
                    <div className="match-header d-flex flex-column pb-5 w-100">

                      {cricket?.length > 0 ? (
                        cricket
                          ?.filter(
                            (item) =>
                              checkOpenDate(item?.event.openDate) === "InPlay" &&
                              cric[item.marketId] &&
                              cric[item.marketId].length > 0 &&
                              cric[item.marketId].some(
                                (market) =>
                                  market?.ex?.availableToBack?.length > 0 ||
                                  market?.ex?.availableToLay?.length > 0
                              )
                          )
                          .map((item, index) => {
                            const marketData = cric[item.marketId] || [];


                            if (!marketData) return null;
                            return (
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competition?.id}
                                className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div >
                                  {/* <p>{item.marketId}</p> */}
                                  <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team"
                                            >

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name t_left fs-4"
                                                onClick={() => handleClick(item)}
                                              >

                                                {/* <div
                                                _ngcontent-jrx-c94=""
                                                className={`${new Date() >= new Date(item?.event.openDate)
                                                  ? "green-circle inplay-blinker ng-star-inserted"
                                                  : ""
                                                  }`}
                                              ></div> */}
                                                {" "}
                                                <span>{item.runners[0].runnerName}{" "}</span>
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                <span>{item.runners[1].runnerName}</span>
                                                <div className="data_date">
                                                  <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">Today</span>   <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex" style={{ marginTop: "2px", }}>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail"
                                            >
                                              {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid" src="/assets/paneal_images/bm-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid ms-1" src="assets/paneal_images/fancy-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid mx-2" src="/assets/paneal_images/patte.webp" />
                                                </span>
                                              </div>

                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper"
                                              style={{ position: "relative", }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >

                                                    {marketData && marketData.length > 0 && (
                                                      <div className="d-flex runnners-odds-details">
                                                        {(() => {
                                                          let backDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToBack?.length > 0
                                                              ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                              : []
                                                          );
                                                          let layDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToLay?.length > 0
                                                              ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                              : []
                                                          );

                                                          // Fill up with empty divs if needed to ensure 6 elements
                                                          while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                          while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                          let combinedDivs = [
                                                            backDivs[0],
                                                            layDivs[0],
                                                            { price: null, type: "Back" }, // Empty Back
                                                            { price: null, type: "Lay" }, // Empty Lay
                                                            backDivs[1],
                                                            layDivs[1],
                                                          ];

                                                          return combinedDivs.map((item, index) => (
                                                            <app-oddsbutton key={index}>
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                              //  onClick={()=>handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !== null ? item.price : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          ));
                                                        })()}
                                                      </div>
                                                    )}

                                                  </div>
                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div>No Matches Found.</div>
                      )}

                      {/* <div>
                      <span className="bg-yellow px-4 py-1 w-25 rad bett">
                        Soccer
                      </span>
                    </div> */}

                      {soccer?.length > 0 ? (
                        soccer
                          ?.filter(
                            (item) =>
                              checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
                              socc[item.marketId] &&
                              socc[item.marketId].length > 0 &&
                              socc[item.marketId].some(
                                (market) =>
                                  market?.ex?.availableToBack?.length > 0 ||
                                  market?.ex?.availableToLay?.length > 0
                              )
                          )
                          .map((item, index) => {
                            const marketData = socc[item.marketId] || [];

                            // console.log('marketdata',marketData);

                            if (!marketData) return null;
                            return (
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competition?.id}
                                className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div >
                                  {/* <p>{item.marketId}</p> */}
                                  <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team"
                                            >

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name t_left fs-4"
                                                onClick={() => handleClick(item)}
                                              >

                                                {/* <div
                                              _ngcontent-jrx-c94=""
                                              className={`${new Date() >= new Date(item?.event.openDate)
                                                ? "green-circle inplay-blinker ng-star-inserted"
                                                : ""
                                                }`}
                                            ></div> */}
                                                {" "}
                                                {item.runners[0].runnerName}{" "}
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                {item.runners[1].runnerName}
                                                <div className="data_date">
                                                  <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">Today</span>   <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex" style={{ marginTop: "2px", }}>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail"
                                            >
                                              {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid" src="/assets/paneal_images/bm-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid ms-1" src="assets/paneal_images/fancy-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid mx-2" src="/assets/paneal_images/patte.webp" />
                                                </span>
                                              </div>

                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper"
                                              style={{ position: "relative", }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >

                                                    {marketData && marketData.length > 0 ? (
                                                      <div className="d-flex runnners-odds-details">
                                                        {(() => {
                                                          let backDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToBack?.length > 0
                                                              ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                              : []
                                                          );
                                                          let layDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToLay?.length > 0
                                                              ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                              : []
                                                          );

                                                          // Fill up with empty divs if needed to ensure 6 elements
                                                          while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                          while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                          let combinedDivs = [
                                                            backDivs[0],
                                                            layDivs[0],
                                                            { price: null, type: "Back" }, // Empty Back
                                                            { price: null, type: "Lay" }, // Empty Lay
                                                            backDivs[1],
                                                            layDivs[1],
                                                          ];

                                                          return combinedDivs.map((item, index) => (
                                                            <app-oddsbutton key={index}>
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                              //  onClick={()=>handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !== null ? item.price : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          ));
                                                        })()}
                                                      </div>
                                                    ) :
                                                      <div>No playinng match</div>
                                                    }

                                                  </div>
                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div>No Playing Match.</div>
                      )}

                      {/* <div>
                      <span className="bg-yellow px-4 py-1 w-25 rad bett">
                        Tennis
                      </span>
                    </div> */}

                      {tennis?.length > 0 ? (
                        tennis
                          ?.filter(
                            (item) =>
                              checkOpenDate(item?.event.openDate) === "InPlay" && // ✅ Only "InPlay"
                              avail[item.marketId] &&
                              avail[item.marketId].length > 0 &&
                              avail[item.marketId].some(
                                (market) =>
                                  market?.ex?.availableToBack?.length > 0 ||
                                  market?.ex?.availableToLay?.length > 0
                              )
                          )
                          .map((item, index) => {
                            const marketData = avail[item.marketId] || [];

                            // console.log('marketdata',marketData);

                            if (!marketData) return null;
                            return (
                              <div
                                key={index}
                                _ngcontent-jrx-c94=""
                                id={item?.competition?.id}
                                className="flex-md-row justify-content-between  rounded ng-star-inserted"
                                style={{ position: "relative" }}
                              >
                                <div>
                                  {/* <p>{item.marketId}</p> */}
                                  <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="section_details_box upcoming-data"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="sport-type-detail"
                                      >
                                        <div
                                          _ngcontent-jrx-c94=""
                                          className="runnners-odds-details"
                                        >
                                          <div
                                            _ngcontent-jrx-c94=""
                                            className="sport-name-wrapper"
                                          >

                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_box_team"
                                            >

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_box_t_name t_left fs-4"
                                                onClick={() => handleClick(item)}
                                              >

                                                {" "}
                                                <span>{item.runners[0].runnerName}{" "}</span>
                                                <span
                                                  _ngcontent-jrx-c94=""
                                                  className="vs ng-star-inserted"
                                                >
                                                  {" "}
                                                  vs{" "}
                                                </span>
                                                <span>{item.runners[1].runnerName}</span>
                                                <div className="data_date">
                                                  <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">{/*new Date(item?.event.openDate).toISOString().split("T")[0]*/}Today</span>   <span style={{ color: themeColors['--dark-theme-data-color'] }} className="fszz">{new Date(item?.event.openDate).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="px-1">|</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex" style={{ marginTop: "2px", }}>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="middle-detail"
                                            >
                                              {/* <div
                                          _ngcontent-jrx-c94=""
                                          className={`${new Date() >= new Date(item?.event.openDate)
                                            ? "green-circle inplay-blinker ng-star-inserted"
                                            : ""
                                            }`}
                                        ></div> */}

                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="small-grid"
                                              >
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid" src="/assets/paneal_images/bm-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid ms-1" src="assets/paneal_images/fancy-icon1.png" />
                                                </span>
                                                <span _ngcontent-jrx-c94="">
                                                  <img className="imgfluid mx-2" src="/assets/paneal_images/patte.webp" />
                                                </span>
                                              </div>

                                            </div>
                                            <div
                                              _ngcontent-jrx-c94=""
                                              className="details_odds_boxes_inn details_small_box_wrapper"
                                              style={{ position: "relative", }}
                                            >
                                              <div
                                                _ngcontent-jrx-c94=""
                                                className="details_small_boxes"
                                              >
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  className="details_small_boxes_let"
                                                >
                                                  <div
                                                    _ngcontent-jrx-c94=""
                                                    className="details_small_boxes_inn ng-star-inserted"
                                                  >

                                                    {marketData && marketData.length > 0 && (
                                                      <div className="d-flex runnners-odds-details">
                                                        {(() => {
                                                          let backDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToBack?.length > 0
                                                              ? [{ price: market.ex.availableToBack[0].price, type: "back" }]
                                                              : []
                                                          );
                                                          let layDivs = marketData.flatMap(market =>
                                                            market?.ex?.availableToLay?.length > 0
                                                              ? [{ price: market.ex.availableToLay[0].price, type: "lay" }]
                                                              : []
                                                          );

                                                          // Fill up with empty divs if needed to ensure 6 elements
                                                          while (backDivs.length < 2) backDivs.push({ price: null, type: "back" });
                                                          while (layDivs.length < 2) layDivs.push({ price: null, type: "lay" });

                                                          let combinedDivs = [
                                                            backDivs[0],
                                                            layDivs[0],
                                                            { price: null, type: "Back" }, // Empty Back
                                                            { price: null, type: "Lay" }, // Empty Lay
                                                            backDivs[1],
                                                            layDivs[1],
                                                          ];

                                                          return combinedDivs.map((item, index) => (
                                                            <app-oddsbutton key={index}>
                                                              <div
                                                                id={index}
                                                                className={`d-md-flex ${item.type === "lay" ? "bg-pink1" : ""
                                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                              //  onClick={()=>handleBetClick(item, index, marketid)}
                                                              >
                                                                <span className="ng-star-inserted">
                                                                  {item.price !== null ? item.price : "--"}
                                                                </span>
                                                              </div>
                                                            </app-oddsbutton>
                                                          ));
                                                        })()}
                                                      </div>
                                                    )}

                                                  </div>
                                                </div>
                                                <div
                                                  _ngcontent-jrx-c94=""
                                                  style={{ clear: "both" }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div>No Matches Found.</div>
                      )}
                    </div>
                  )}
                </app-upcoming>

                {/* <Footer /> */}
              </div>
            </div>
            <MarqueeBottom onMenuClick={handleCanvasShow} />
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};
export default InplayGames;
